<template>
  <div :class="padding">
    <div
      class="text--center py--24px"
      v-if="!title"
    >
      <strong class="font--28px font--800 lh--1 pb--20px text--center">{{boardName}}</strong>
      <p class="font--14px pt--12px">{{boardDeco.subTitle}}</p>
    </div>
    <div
      v-else
      v-html="title"
    ></div>
    <board-list
      v-if="type === 'list'"
      :boardId="this.boardId"
      :rows="board.rows"
      :goView="goView"
      class1="columns--3 view--text"
      class2="view--thum thum--md thum--left view--text view--list-name"
      :class="css"
    ></board-list>
    <quick-board-table
      v-else
      :boardId="this.boardId"
      :rows="board.rows"
      :goView="goView"
      :class="css"
      :useOptions="useOptions"
    ></quick-board-table>
    <!-- <div class="text--center">
      <a href="#">dd</a>
    </div> -->
  </div>
</template>

<script>
import quickBoard from './js/quickBoard'
import boardMeta from './js/boardMeta'

export default {
  mixins: [quickBoard, boardMeta],
  props: {
    type: { type: String, default: 'table' },
    title: { type: String, default: '' },
    css: { type: String, default: '' }
  },
  computed: {
    padding () {
      return this.$mq === 'mobile' ? 'px--16px' : 'p--40px'
    }
  },
  components: {
    QuickBoardTable: () => import('./component/QuickBoardTable'),
    BoardList: () => import('./component/BoardList')
  }
}
</script>
